var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalWave2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1320,
    height: 73,
    viewBox: "0 0 1320 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.3607C220 -4.45358 440 -4.45358 660 13.3607C880 32.3369 1100 32.3369 1320 13.3607V73H0",
    fill: "#E2ECF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalWave2);
export default __webpack_public_path__ + "static/media/modalWave2.002b3ff06a161744e5f9a70be8f1b90b.svg";
export { ForwardRef as ReactComponent };